<template>
    <b-container fluid  class="headerPushDown">
        <b-container v-if="getSelectedItem" class="ml-auto mr-auto p-0">
            <b-row class="p-0">
            <b-col sm="12" md="12" class="p-0">
                <shop-ticket-service v-bind:getSelectedItemId="getSelectedItem.id" v-on:setTableSelected="setIsTableSelected"/>
            </b-col>

            <b-col sm="12" md="12" v-if="isTableSelected">
                <!-- ADD TO CART BUTTON -->
                <b-button v-if="!isFree" @click="addToCart" class="mt-2 text-uppercase" size="md" variant="light" style="float: right;">
                    {{this.getLanguageItem['ShopUi']['buttonAddToCart']}}
                </b-button>

                <!-- DIRECT BOOKING MODAL -->
                <b-button v-if="isFree" to="/app/directbooking" class="mt-2 text-uppercase mr-2" size="md" variant="light" style="float: right;">
                    Reservieren
                </b-button>
            </b-col>
            </b-row>
        </b-container>

  </b-container>
</template>

<script>
import ShopTicketService from "@/components/ShopTicketService";


export default {
    name: 'ShopBookingIndex',
    components: {
        ShopTicketService,
    },
    data(){
        return{
           SelectedItemId: undefined,
            isTableSelected: false,
        }
    },
    methods: {
        setIsTableSelected: function(selected){
      //console.log('isTableSelected: ', selected);
      this.isTableSelected = selected;
    },
    async loadGroupsFromServer(searchTags) {

        let config = this.$store.getters.getRestHeaderConfig;
        config.params = {
            searchTags: searchTags,
            imageSize: "big" /* small, medium, big */,
            localeId: this.getSelectedLanguage.ident /* Language: de, en */
        };

        await this.$http
            .get(
            this.$store.getters.getRestServerBaseUrl + "/productGroups", config)
            .then(response => {
                //console.log("productGroups: ", searchTags, response.data);
                // Check Data ?
                if(response.data != undefined && response.data.length > 0 ){
                    // load a la carte ( first item! in list)
                    this.loadProductsFromServer(response.data[0]);

                }else{
                  //  console.log('productGroups ERROR: No Data received');
                }

            })
            .catch(err => {
                console.log('Get Group datafailed: ', err);

            });
        },
        async loadProductsFromServer(group) {
            let config = this.$store.getters.getRestHeaderConfig;
            config.params= {
                groupId: group.id,
                imageSize: "big" /* small, medium, big */,
                localeId: this.getSelectedLanguage.ident /* Language: de, en */
            };

            // GroupProducts
            await this.$http
                .get(this.$store.getters.getRestServerBaseUrl + "/products", config)
                .then(response2 => {
                   // console.log("Products OK: ", response2.status, group.id , response2.data );

                    // we are only interessted in the very first item


                   this.SelectedItemId = response2.data[0].id;

                   this.loadProductFromServer(response2.data[0].id);


                })
                .catch(err => {
                    console.log("/products ERORR", err);
                });
        },
        async loadProductFromServer(productId) {
            let config = {
                header: this.$store.getters.getRestHeader,
                params: {
                productId: productId,
                imageSize: "medium" /* small, medium, big */,
                localeId: this.getSelectedLanguage.ident /* Language: de, en */
                }
            };

            await this.$http
                .get(this.$store.getters.getRestServerBaseUrl + "/productDetail", config)
                .then(response => {
               // console.log("GET product Detail: " + response.status , response.data);

                 response.data.count = 1;
                    response.data.amountOfPersons = 1; // used in Tickets
                    response.data.selectedLayout = undefined;
                    response.data.selectedTemplate = undefined;

                    // fix GroupPerson
                    if (response.data.personGroups) {
                        response.data.personGroups.forEach(g => {
                        // add count and sum to cachedObject
                        g.count = 0;
                        g.index = 0;
                        });
                    }

                    // fix List
                    if (response.data.prices) {
                        response.data.prices.forEach(p => {
                        p.count = 0;
                        });
                    }


                this.$store.dispatch("updateCachedItems", response.data);

                //console.log('Post cache: ', this.getSelectedItem);


            })
            .catch(err => {
            console.log("GET productDetail ERROR: ", err);
            this.panelData = {};
            });
    },
    },
    computed:{
        getSelectedLanguage() {
            return this.$store.getters.getLanguage;
        },
        getLanguageItem: function() {
            return this.$store.getters.getLanguageStrings;
        },
        getSelectedItem: function() {
           // console.log('get item: ', this.SelectedItemId);

            return this.$store.getters.getCachedItemById(this.SelectedItemId);
        },
        isFree(){
        //console.log('is free? ', this.getSelectedItem.free);
            return this.getSelectedItem.free;
        }
    },
    beforeMount(){
        this.$store.dispatch('saveCustomerShiftTicket', undefined);
        this.loadGroupsFromServer('SidemenuAlaCarte');
    },
    mounted(){
        window.scroll({
            top:0,
            left:0,
            behavior:'smooth'
        });
    }
}
</script>
